import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import PropTypes from 'prop-types';
import { getDonutChartOptions } from 'config/highcharts';
import { sortdData } from 'utils/highcharts.utils';

Highcharts.setOptions({
  credits: { enabled: false }
});

const WorkersInBlockChart = ({ data = [] }) => {
  const chartData = data.map(d => ({
    name: d.blockName || 'Unknown Block',
    y: parseInt(d.workerCount || 0),
    max: parseInt(d.workerCount || 0)
  }));

  const total = chartData.reduce((sum, item) => sum + item.y, 0);

  const chartOptions = getDonutChartOptions({
    data: sortdData(chartData),
    title: `${total} Workers`,
    useFormatter: true
  });

  return (
    <div className="w-full min-h-[600px] p-6">
      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
    </div>
  );
};

export default WorkersInBlockChart;

WorkersInBlockChart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object)
};
